import { render } from "./LoadingSpinner.vue?vue&type=template&id=83d6ccbe&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=83d6ccbe&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/binity-tour/binity-tour/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83d6ccbe"]])

export default __exports__